import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // Preserve the destination the user was navigating to (search + pathname).
        // If they were at "/" default to /account. Downloads page reads a ?claim=<slug>
        // query param and auto-triggers the file download.
        const target =
          (location.pathname && location.pathname !== "/" ? location.pathname : "/account") +
          (location.search || "");
        // Clear the OAuth hash before navigating
        window.history.replaceState(null, "", location.pathname + (location.search || ""));
        navigate(target, { replace: true, state: { user: data } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-[60vh] grid place-items-center bg-[#0B0B0B]" data-testid="auth-callback-page">
      <div className="text-center">
        <Loader2 className="mx-auto text-[#1565FF] animate-spin" size={32} />
        <div className="mt-6 label-mono">Establishing secure session…</div>
      </div>
    </div>
  );
}
